import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/index.css';
import SupplyChainStages from '../components/SupplyChainStages';
import Brand from '../components/Brand';
import SEO from '../components/SEO';

const Solutions: React.FC = () => {
  const navigate = useNavigate();
  const goToDemo = () => navigate('/request-demo');

  return (
    <div className="home-container">
      <SEO
        title="Solutions for Procurement, Inventory & Asset Operations"
        description="See how OpenUse's mobile-first products replace spreadsheets and email with structured RFQ sourcing, inventory control, and asset tracking."
        path="/solutions"
      />
      <div className="hero-section solutions-hero">
        <div className="hero-content">
          <p className="hero-eyebrow">Solutions</p>
          <h1 className="hero-headline">
            Operational systems your team will actually use.
          </h1>
          <p>
            <Brand /> builds four products for the moments where most
            organizations still rely on spreadsheets, email, and tribal
            knowledge: clinical supply, supplier sourcing, inventory, and
            physical assets.
          </p>
        </div>
      </div>

      <section className="solutions-section">
        <h2 className="section-title">How we approach operations</h2>
        <p className="section-subtitle">
          Three principles guide every product decision we make.
        </p>
        <div className="services-grid">
          <div className="card">
            <h3>Reflect the work</h3>
            <p>
              Software has to look like the actual workflow — rooms, carts,
              RFQs, SKUs — not like a generic database. Configuration is
              measured in hours, not quarters.
            </p>
          </div>
          <div className="card">
            <h3>Capture at the source</h3>
            <p>
              The data is only as good as the moment it’s captured. We design
              mobile-first capture so the system reflects what actually
              happened on the floor.
            </p>
          </div>
          <div className="card">
            <h3>Make it auditable</h3>
            <p>
              Every action is logged, exportable, and defensible. Operations
              leaders can answer questions from finance, compliance, or the
              board without rebuilding history.
            </p>
          </div>
        </div>
      </section>

      <SupplyChainStages />

      <section className="solutions-section">
        <div className="solutions-cta-row">
          <button className="hero-cta primary" onClick={goToDemo}>Talk to sales</button>
        </div>
      </section>
    </div>
  );
};

export default Solutions;
